import React, {useMemo, useState} from "react";
import {useTranslate} from "../../../hooks/translate.hook";
import {SmartTable} from "../../common/smart-table/smart-table";
import {SmartTableDataHandler} from "../../common/smart-table/smart-table.data-handler";
import {Button, Space} from "antd";
import {declarationsCodesService} from "../../../services/declarations/declarations.codes.service";
import {columnsFactory} from "./declarations.codes.columns";
import {DeclarationsCode} from "../../../models/declarations/declarations.codes";
import {DeclarationCodeEditModal} from "./modal/edit/declaration.code.edit.modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const DeclarationsCodes: React.FC = () => {
    const t = useTranslate();

    const columns = useMemo(() => columnsFactory(t), []);
    const handler = useMemo(() => new SmartTableDataHandler(request => declarationsCodesService.getAll(request)), []);

    const [modalShown, setModalShown] = useState<boolean>(false);
    const [modalItem, setModalItem] = useState<DeclarationsCode | null>(null);

    const openModal = (item: DeclarationsCode | null) => {
        setModalShown(true);
        setModalItem(item);
    }

    const closeModal = async () => {
        setModalShown(false);
        setModalItem(null);
        await handler.reloadItemsWithLastRequest();
    }

    const remove = async (item: DeclarationsCode) => {
        await declarationsCodesService.remove(item.id);
        await handler.reloadItemsWithLastRequest();
    }

    return (
        <Space direction={"vertical"} size={[10, 10]}>
            <Button
                type={"primary"}
                onClick={() => openModal(null)}
                icon={<FontAwesomeIcon icon={["fas", "plus"]} />}
            >
                {t('CREATE')}
            </Button>
            <SmartTable
                columns={columns}
                handler={handler}
                actions={[
                    {
                        icon: 'edit',
                        title: t('EDIT'),
                        onClick: openModal
                    },
                    {
                        icon: 'trash',
                        title: t('REMOVE'),
                        onClick: remove
                    }
                ]}
            />
            {modalShown ? (
                <DeclarationCodeEditModal item={modalItem} onClose={closeModal} />
            ) : null}
        </Space>
    );
};

